import React from "react";
import { Column } from "@allxsmith/bestax-bulma";

function Figure(props) {
  return (
    <Column>
      {props.label}: £
            {props.loaded && props.value != null
        ? props.value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : "Loading..."}
    </Column>
  );
}

export default Figure;
